<template>
  <div class="mamMasterSubscripting page-box">
    <div class="page-content">
      <div class="content-header">
        <el-row
          :gutter="20"
        >
          <el-col
            :lg="8"
            :md="8"
            :sm="12"
            :xs="24"
          >
            <el-date-picker
              v-if="!realMobile"
              class="header-sub-item"
              style="width: 100%"
              v-model="date"
              @change="toQuery"
              type="daterange"
              :range-separator="$t('root.dateTo')"
              :start-placeholder="$t('root.startDate')"
              :end-placeholder="$t('root.endDate')"
            >
            </el-date-picker>
            <select-date-duration
              class="header-sub-item"
              v-model="date"
            ></select-date-duration>
          </el-col>
          <el-col
            :lg="4"
            :md="8"
            :sm="12"
            :xs="12"
          >
            <el-select
              class="self-select header-sub-item"
              style="width: 100%"
              v-model="status"
              clearable
              :placeholder="$t('copyMaster.Subscription_status')"
              @change="toQuery"
            >
              <el-option
                class="self-mtlist-select"
                v-for="(item,index) in statusList"
                :key="index"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <div class="el-table-outer">
        <el-table
          :data="listData"
          v-loading="loading"
          :empty-text="$t('root.noData')"
          class="mam-master-subscrinpting-el-table"
          @sort-change="sortChange"
          @selection-change="handleSelectionChange"
          :header-cell-style="{ background: '#F3F2F7',color: '#5E5873' }"
        >
          <div class="table-nodata" slot="empty">
            {{$t('root.noData')}}
          </div>
          <el-table-column
            type="selection"
            key="1"
            :selectable="selectable"
          >
          </el-table-column>
          <el-table-column
            :label="$t('client')"
            key="2"
            min-width="160px"
          >
            <template slot-scope="scope">
              <div>{{scope.row.alias}}</div>
              <span class="font999">{{scope.row.login}}</span>
            </template>
          </el-table-column>
          <el-table-column
            key="3"
            prop="copyBalance"
            :label="$t('User.commissionBanlance')"
            sortable
          >
          </el-table-column>
          <!--            <el-table-column
                              key="4"
                              prop="managementAmount"
                              :label="$t('Manage_funds')"
                              sortable
                              min-width="100px"
                      >
                      </el-table-column>-->
          <el-table-column
            key="5"
            prop="login"
            :label="$t('Allocation')"
            min-width="120px"
          >
            <template slot-scope="scope">
              <template>
                <div>{{getStrategy(scope.row, self)}}</div>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            key="6"
            prop="copyNum"
            :label="$t('Current_follow')"
            sortable
            min-width="120px"
          >
            <template slot-scope="scope">
              {{scope.row.copyNum || 0}}{{$t('transactions')}}
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
              >
                <div class="" slot="content">
                  {{$t('Maximum_follow_number')}}{{scope.row.copyMaxNum}}{{$t('transactions')}}
                </div>
                <el-progress
                  v-if="scope.row.copyMaxNum"
                  :format="format"
                  :percentage="getPercentage(scope.row)"
                  :color="getProgressColor(scope.row)"
                ></el-progress>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            key="7"
            prop="copyLots"
            :label="$t('Current_follow_lot')"
            min-width="120px"
          >
            <template slot-scope="scope">
              {{scope.row.copyLots || 0}}{{$t('Home.forexLot')}}
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
              >
                <div class="" slot="content">
                  {{$t('Maximum_follow_lot')}}{{scope.row.copyMaxLots	}}{{$t('Home.forexLot')}}
                </div>
                <el-progress
                  v-if="scope.row.copyMaxLots"
                  :format="format"
                  :percentage="getPercentageLots(scope.row)"
                  :color="getProgressColorLots(scope.row)"
                ></el-progress>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            key="8"
            prop="statProfit"
            :label="$t('Subscription_revenue')"
            sortable
            min-width="100px"
          >
            <template slot-scope="scope">
                    <span :class="{
                        'theme-color':   isIncludeMinus(scope.row.statProfit) == true,
                        'theme-green':   isIncludeMinus(scope.row.statProfit) == false,
                    }">{{scope.row.statProfit}}</span>
            </template>
          </el-table-column>
          <el-table-column
            key="9"
            prop="subDays"
            :label="$t('Subscription_days')"
            sortable
            min-width="100px"
          >
            <template slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top"
              >
                <div class="" slot="content">
                  {{scope.row.beginDate}}-
                </div>
                <span>{{scope.row.subDays}} {{$t('day')}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            key="10"
            prop="amount"
            :label="$t('Automatic_renewal')"
          >
            <template slot-scope="scope">
              <span>{{scope.row.isRenew === 1 ? $t('Yes'): $t('Not')}}</span>
            </template>
          </el-table-column>
          <el-table-column
            key="11"
            prop=""
            :label="$t('Follow_the_order')"
          >
            <template slot-scope="scope">
              <span
                class="follow-order"
              >{{getFollowText(scope.row.copyStatus)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="$t('copyMaster.Subscription_status')"
          >
            <template
              slot-scope="scope"
            >
              <span
                class="tag-box tag"
                :style="getStatusStyle(scope.row.status)"
              >{{getStatus(scope.row.status)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            key="12"
            :label="$t('Trade.oper')"
          >
            <template slot-scope="scope">
              <span
                v-if="scope.row.status === 0"
                class="pointer"
                @click="followSettingHandle(scope.row)"
              >{{$t('Follow_the_set')}}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">{{$t('total')}} {{total}} {{$t('item')}}</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <copySubmitBar
      class="copy-footer-outer copy-submit-bar"
      :style="copyFooterStyle"
      :current-page-select="multipleSelection"
    ></copySubmitBar>
  </div>
</template>

<script>
import {colorRgba} from "@/utils/index";
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index'
import { getStrategy,isIncludeMinus } from '@/utils/common';
import initData from '@/mixins/initData';
import copySubmitBar from '@/components/user/details/common/copySubmitBar'
import TheFooter from "@/layouts/components/TheFooter";
import TheNavbarVertical from "@/layouts/components/navbar/TheNavbarVertical";
import VNavMenu from "@/layouts/components/vertical-nav-menu/VerticalNavMenu";
export default {
  name: 'index',
  components: {
    copySubmitBar,
  },
  mixins: [initData],
  data() {
    return {
      statistics:{
        profitSum: '',
      },
      self: {},

      date: [],
      status: '',
      statusList: [
        {
           label: this.$t('valid'),
           value: 0,
        },
        {
          label: this.$t('finished'),
          value: 1,
        },
        {
          label: this.$t('unsubscribe'),
          value: 2,
        },
        {
          label: this.$t('copyMaster.Not_active'),
          value: 3,
        },
        {
          label: this.$t('Settlement'),
          value: 4,
        },
      ],

      green: '#28C76F',
      yellow: '#FF9F43',
      grayBg: '#BABFC7',
      grayColor: '#BABFC7',


      multipleSelection: [],
    };
  },
  created(){
    this.self = this;
    this.$nextTick(() => {
      this.init();
    })
  },
  computed: {
    ...mapGetters(['copyingSelectData','listRefresh','realMobile']),
    verticalNavMenuWidth() {
      return this.$store.getters.verticalNavMenuWidth
    },
    copyFooterStyle(){
      if(this.verticalNavMenuWidth == 'default'){
        return {
          paddingLeft: '290px'
        }
      }else {
        return {
          paddingLeft: '120px'
        }
      }
    },
  },
  watch:{
    listRefresh(){
      this.init()
    },
    date(val){
      if(this.realMobile){
        this.init();
      }
    },
  },
  methods: {
    parseTime,
    getStrategy,
    isIncludeMinus,
    beforeInit(){
      this.params = {
        mtId: this.$route.params.mtid,
        page: this.page -1,
        size: this.size,
      }
      if(this.sort){
        this.params.sort = this.sort;
      }
      if(this.date && this.date.length >= 2){
        this.params.startTime = parseTime(this.date[0]);
        this.params.endTime = parseTime(this.date[1]);
      }
      if(this.status){
        this.params.status = this.status;
      }
      this.url = '/crm/reception/queryMasterSubscription';
      return true;
    },
    selectable(row,index){
      //订阅关系有效的才可以选中, todo
      if(row.status === 0){
        return true;
      }else {
        return false;
      }
    },
    getStatusMinWidth(){
      if(this.language == 'en_US'){
        return '150px';
      }else {
        return '';
      }
    },
    getPercentage(row){
      return (row.copyNum / row.copyMaxNum) * 100;
    },
    getProgressColor(row){
      if(this.getPercentage(row) <= 50){
        return '#11AC80'
      }else if(this.getPercentage(row) > 50 && this.getPercentage(row) < 100){
        return '#FF8102'
      }else if(this.getPercentage(row) == 100){
        return '#E44F47'
      }
    },
    getPercentageLots(row){
      return (row.copyLots / row.copyMaxLots) * 100;
    },
    getProgressColorLots(row){
      if(this.getPercentageLots(row) <= 50){
        return '#11AC80'
      }else if(this.getPercentageLots(row) > 50 && this.getPercentageLots(row) < 100){
        return '#FF8102'
      }else if(this.getPercentageLots(row) == 100){
        return '#E44F47'
      }
    },
    getStatusStyle(status){
      switch (status){
        case 0:
          return {
            backgroundColor: colorRgba(this.green,0.1),
            color: this.green,
          };
        case 1:
          return {
            backgroundColor: colorRgba(this.yellow,0.1),
            color: this.yellow,
          };
        case 2:
        case 3:
        case 4:
          return {
          backgroundColor: colorRgba(this.grayBg,0.1),
          color: this.grayColor,
        };
      }
    },
    getStatus(status){
      switch (status){
        case 0:
          return this.$t('valid');
        case 1:
          return this.$t('finished');
        case 2:
          return this.$t('unsubscribe');
        case 3:
          return this.$t('copyMaster.Not_active');
        case 4:
          return this.$t('Settlement');
      }
    },
    format(){
      return '';
    },
    getFollowText(copyStatus){
      return copyStatus ? this.$t('normal'): this.$t('copyMaster.pause');
    },
    followSettingHandle(row){
      this.$store.commit('setMasterAccountEditSubscrpitDialogType', 'mam');
      this.$store.commit('setCurrentMasterMtId', this.$route.params.mtid);

      this.$store.commit('setCopyingSelectMultiple', false);

      this.$store.commit('setMasterAccountEditSubscrpitParams', row);
      this.$store.commit('setCopyingSelectData', [{
        copyAlias: row.copyAlias,
        id: row.id,
        login: row.login,
        managementAmount: row.managementAmount,
        copyLeverage: row.copyLeverage,
      }]);
      this.$store.commit('setMasterAccountEditSubscrpitDialogShow', true);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;

      // 改业务代码在 copySubmitBar组件
      /*if(val.length == 1){
        this.$store.commit('setMasterAccountEditSubscrpitParams', val[0]);

      }else {

      }
      this.$store.commit('setCopyingSelectData', val);*/
    },
  }
};
</script>
<style lang="scss">
.content-wrapper {
  min-height: calc(var(--vh, 1vh) * 100 - 9.5rem)!important;
}
</style>
<style lang="scss" scoped>
@import "../../../assets/scss/variable";
.mamMasterSubscripting {
  .el-table-outer {
    overflow-x: auto;
    /deep/ .mam-master-subscrinpting-el-table {
      min-width: 1200px;
      margin-bottom: 0;
    }
  }
  .header-sub-item {
    margin-bottom: 10px;
  }
  .icon-dot {
    display: inline-block;
    width: 8px;
    height: 8px;
    background-color: $themeColor;
    border-radius: 50%;
    &.on {
      background-color: $themeGreen;
    }
  }
}
// 移动端样式
@media screen and (max-width: 768px){
  .copy-footer-outer {
    padding-right: 0;
  }
}
.copy-submit-bar {
  z-index: 99;
}
</style>
